import type {
    IDigitalGiftSkusInput,
    IDigitalGiftAddOutput,
    IDigitalGiftAddToWalletInput,
    IDigitalGiftAddToWalletOutput,
    IDigitalGiftHistoryInput,
    IDigitalGiftResendInput,
    IDigitalGiftDownloadPdfInput
} from "@types";
import gate from "../gate";
import client, { fileDownloadClient } from "../http-clients/api";

const DigitalGiftApi = {
    getSkus: () =>
        gate.get<IDigitalGiftSkusInput, never, never>({
            client,
            url: "digitalGift/skus",
        }),

    addDigitalGift: (data: IDigitalGiftAddOutput) =>
        gate.post<any, IDigitalGiftAddOutput, never>({
            client,
            url: "digitalGift/addDigitalGift",
            data,
        }),

    addDigitalGiftToWallet: (data: IDigitalGiftAddToWalletOutput) =>
        gate.post<IDigitalGiftAddToWalletInput, IDigitalGiftAddToWalletOutput, never>({
            client,
            url: "digitalGift/addDigitalGiftToWallet",
            data,
        }),
    getHistory: () =>
        gate.get<IDigitalGiftHistoryInput, never, never>({
            client,
            url: "digitalGift/history",
        }),

    resendDigitalGift: (digital_gift_id: number) =>
        gate.get<any, never, IDigitalGiftResendInput>({
            client,
            url: `digitalGift/resendDigitalGift?digital_gift_id=${digital_gift_id}`,
        }),

    downloadPdf: (orderId: string) =>
        gate.get<Blob, never, never>({
            client: fileDownloadClient,
            url: `digitalGift/${orderId}/downloadPdf`,
        }),

    downloadPdfs: (orderId: string) =>
        gate.get<Blob, never, never>({
            client: fileDownloadClient,
            url: `digitalGift/${orderId}/downloadPdfs`,
        }),
};

export default DigitalGiftApi; 